const config = {
    configuration: true,
    buttonList: [
        {
            type: 'text',
            icon: 'el-icon-refresh',
            label: '刷新',
            size: 'small',
            event: 'refresh',
        },
        {
            type: 'text',
            class: 'bigData-btn-ltc-add',
            icon: 'el-icon-circle-plus-outline',
            label: '新增',
            size: 'small',
            event: 'add'
        },
        {
            type: 'text',
            class: 'bigData-btn-ltc-save',
            icon: 'el-icon-circle-check',
            label: '保存',
            size: 'small',
            event: 'save'
        },
        {
            type: 'text',
            class: 'bigData-btn-ltc-delete',
            icon: 'el-icon-delete',
            label: '删除',
            size: 'small',
            event: 'delete'
        }
    ],
    table:
    {
        selectBtn: true,
        tableCut: true,
        clickModify: true,
        height: 'calc(100vh - 412px)',
        leftOperation: true,
        columns: [
            {
                label: '零担对接平台',
                prop: 'exchangePlatform',
                type: 'select',
                optionNum: 'SRM_LESS_PLATFORM',
                options: [],
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '专线名称',
                prop: 'accountName',
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '专线账号',
                prop: 'professionalAccount',
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '专线KEY',
                prop: 'professionalKey',
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '状态',
                prop: 'enableFlag',
                type: 'select',
                options: [
                    { label: '停用', value: 0 },
                    { label: '启用', value: 1 }
                ],
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '150'
            },
            {
                label: '最后修改人',
                prop: 'updateUserName',
                width: '150'
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                width: '150'
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'mini',
                event: 'edit'
            }
        ],
        leftWidth: 60
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100]
    }
};

export default config;
